<template>
  <div>
    <b-button-group
      ref="paginator"
      class="w-100 mb-2"
    >
      <b-button
        size="sm"
        @click="prevPage"
      >
        <i class="fa fa-lg fa-angle-left" />
      </b-button>
      <b-button class="flex-grow-1">
        {{ value }}
        {{ $dt('global.of', 'of') }} {{ Math.ceil(items.length / perPage) }}
      </b-button>

      <b-button
        size="sm"
        @click="nextPage"
      >
        <i class="fa fa-angle-right" />
      </b-button>
    </b-button-group>
    <div
      v-for="(item, index) in currentPageItems"
      :key="index"
    >
      <slot :item="item" :index="index" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PagniatedScroll',
  props: {
    // current page
    value: {
      type: Number,
      default: 1
    },
    items: {
      type: Array,
      required: true
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  mounted() {
    /** @type {{paginator: HTMLDivElement}} */
    const { paginator } = this.$refs;
    paginator.addEventListener('wheel', this.onWheel.bind(this));
  },
  beforeDestroy() {
    /** @type {{paginator: HTMLDivElement}} */
    const { paginator } = this.$refs;
    paginator.removeEventListener('wheel', this.onWheel.bind(this));
  },
  computed: {
    currentPageItems() {
      return this.items.slice((this.value - 1) * this.perPage, this.value * this.perPage);
    },
  },
  methods: {
    /** @param {WheelEvent} event */
    onWheel(event) {
      if (event.altKey || event.ctrlKey || event.shiftKey || event.metaKey) {
        return;
      }

      event.preventDefault();
      if (event.deltaY > 0) {
        this.nextPage();
      } else if (event.deltaY < 0) {
        this.prevPage();
      }
    },
    nextPage() {
      const isLastPage = this.value * this.perPage >= this.items.length;
      if (!isLastPage) {
        this.$emit('input', this.value + 1);
      }
    },
    prevPage() {
      const isFirstPage = this.value === 1;
      if (!isFirstPage) {
        this.$emit('input', this.value - 1);
      }
    },
  },
});
</script>
